import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';
import { startGoogleSignIn } from '@/lib/googleOAuth';
import {
  LandingNav, LandingHero, LandingStats, LandingSubjects,
  LandingFeatures, LandingPricing, LandingTestimonials,
  LandingCTA, LandingFooter,
} from '@/components/landing/sections';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LandingPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [stats, setStats] = useState({ units: 78, sources: 957, grades: 6 });
  const [tiers, setTiers] = useState(null);

  useEffect(() => {
    if (user && user.status === 'approved') {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  useEffect(() => {
    axios.get(`${API}/export/stats`)
      .then((res) => {
        if (res.data?.total_units) {
          setStats({ units: res.data.total_units, sources: 957, grades: 6 });
        }
      })
      .catch(() => {});
    // Pull Stripe tier config so the Pricing section shows real prices,
    // never hard-coded numbers.
    axios.get(`${API}/subscription/tiers`)
      .then((res) => setTiers(res.data?.tiers || null))
      .catch(() => {});
  }, []);

  const handleGoogle = async () => {
    try { await startGoogleSignIn(); }
    catch (err) { toast.error(err?.message || 'Could not start Google sign-in'); }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] text-[#2D3748]">
      <LandingNav
        onTour={() => navigate('/tour')}
        onAbout={() => navigate('/about')}
        onSignIn={() => navigate('/login')}
      />
      <LandingHero
        stats={stats}
        onGoogle={handleGoogle}
        onSignIn={() => navigate('/login')}
        onTour={() => navigate('/tour')}
      />
      <LandingStats stats={stats} />
      <LandingSubjects />
      <LandingFeatures />
      <LandingPricing
        tiers={tiers}
        onGoogle={handleGoogle}
        onSignIn={() => navigate('/subscription')}
        onContact={() => navigate('/contact')}
      />
      <LandingTestimonials onAbout={() => navigate('/about')} />
      <LandingCTA
        onGoogle={handleGoogle}
        onPricing={() => navigate('/subscription')}
      />
      <LandingFooter
        onTour={() => navigate('/tour')}
        onPricing={() => navigate('/subscription')}
        onSignIn={() => navigate('/login')}
        onAbout={() => navigate('/about')}
        onToolkit={() => navigate('/teacher-toolkit')}
        onPrivacy={() => navigate('/privacy')}
        onTerms={() => navigate('/terms')}
        onContact={() => navigate('/contact')}
      />
    </div>
  );
}
